import { render } from "./SectionLayout.vue?vue&type=template&id=6256cb3a&scoped=true"
import script from "./SectionLayout.vue?vue&type=script&lang=js"
export * from "./SectionLayout.vue?vue&type=script&lang=js"

import "./SectionLayout.vue?vue&type=style&index=0&id=6256cb3a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6256cb3a"]])

export default __exports__